import 'bootstrap/dist/css/bootstrap.min.css'
import React, { Fragment } from 'react'
import { NavBarV2, FooterV2, MyPgaBannerAd } from '../'
import styled, { ThemeProvider, keyframes } from 'styled-components'
import theme from '../../theme'
import { string, object } from 'prop-types'
import { Global } from '../../GlobalStylesNew'
import SEO from '../SEO'

const fadeIn = keyframes`
  0% {
      opacity: 0;
  }
  50% {
      opacity: 0;
  }
  100% {
      opacity: 1;
  }
`
const Fade = styled.div`
  -webkit-animation: ${fadeIn} 2s linear;
  -moz-animation: ${fadeIn} 2s linear;
  -ms-animation: ${fadeIn} 2s linear;
  -o-animation: ${fadeIn} 2s linear;
  animation: ${fadeIn} 2s linear;
`

const LayoutV2 = ({ children }) => (
  <>
    <Global />
    <SEO />
    <Fade>
      <ThemeProvider theme={theme}>
        <Fragment>
          <NavBarV2 />
          <MyPgaBannerAd />
          <main>{children}</main>
          <FooterV2 />
        </Fragment>
      </ThemeProvider>
    </Fade>
  </>
)

LayoutV2.propTypes = {
  title: string,
  query: object
}
export default LayoutV2
